export const IOS_WATCH_MODEL = {
  'Watch1,1': {
    name: 'Apple Watch 38mm case',
    displayName: 'Apple Watch'
  },
  'Watch1,2': {
    name: 'Apple Watch 42mm case',
    displayName: 'Apple Watch'
  },
  'Watch2,6': {
    name: 'Apple Watch Series 1 38mm case',
    displayName: 'Apple Watch Series 1'
  },
  'Watch2,7': {
    name: 'Apple Watch Series 1 42mm case',
    displayName: 'Apple Watch Series 1'
  },
  'Watch2,3': {
    name: 'Apple Watch Series 2 38mm case',
    displayName: 'Apple Watch Series 2'
  },
  'Watch2,4': {
    name: 'Apple Watch Series 2 42mm case',
    displayName: 'Apple Watch Series 2'
  },
  'Watch3,1': {
    name: 'Apple Watch Series 3 38mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 3'
  },
  'Watch3,2': {
    name: 'Apple Watch Series 3 42mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 3'
  },
  'Watch3,3': {
    name: 'Apple Watch Series 3 38mm case (GPS)',
    displayName: 'Apple Watch Series 3'
  },
  'Watch3,4': {
    name: 'Apple Watch Series 3 42mm case (GPS)',
    displayName: 'Apple Watch Series 3'
  },
  'Watch4,1': {
    name: 'Apple Watch Series 4 40mm case (GPS)',
    displayName: 'Apple Watch Series 4'
  },
  'Watch4,2': {
    name: 'Apple Watch Series 4 44mm case (GPS)',
    displayName: 'Apple Watch Series 4'
  },
  'Watch4,3': {
    name: 'Apple Watch Series 4 40mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 4'
  },
  'Watch4,4': {
    name: 'Apple Watch Series 4 44mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 4'
  },
  'Watch5,1': {
    name: 'Apple Watch Series 5 40mm case (GPS)',
    displayName: 'Apple Watch Series 5'
  },
  'Watch5,2': {
    name: 'Apple Watch Series 5 44mm case (GPS)',
    displayName: 'Apple Watch Series 5'
  },
  'Watch5,3': {
    name: 'Apple Watch Series 5 40mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 5'
  },
  'Watch5,4': {
    name: 'Apple Watch Series 5 44mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 5'
  },
  'Watch5,9': {
    name: 'Apple Watch SE 40mm case (GPS)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch5,10': {
    name: 'Apple Watch SE 44mm case (GPS)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch5,11': {
    name: 'Apple Watch SE 40mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch5,12': {
    name: 'Apple Watch SE 44mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch6,1': {
    name: 'Apple Watch Series 6 40mm case (GPS)',
    displayName: 'Apple Watch Series 6'
  },
  'Watch6,2': {
    name: 'Apple Watch Series 6 44mm case (GPS)',
    displayName: 'Apple Watch Series 6'
  },
  'Watch6,3': {
    name: 'Apple Watch Series 6 40mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 6'
  },
  'Watch6,4': {
    name: 'Apple Watch Series 6 44mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 6'
  },
  'Watch6,6': {
    name: 'Apple Watch Series 7 41mm case (GPS)',
    displayName: 'Apple Watch Series 7'
  },
  'Watch6,7': {
    name: 'Apple Watch Series 7 45mm case (GPS)',
    displayName: 'Apple Watch Series 7'
  },
  'Watch6,8': {
    name: 'Apple Watch Series 7 41mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 7'
  },
  'Watch6,9': {
    name: 'Apple Watch Series 7 45mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 7'
  },
  'Watch6,10': {
    name: 'Apple Watch SE 40mm case (GPS)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch6,11': {
    name: 'Apple Watch SE 44mm case (GPS)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch6,12': {
    name: 'Apple Watch SE 40mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch6,13': {
    name: 'Apple Watch SE 44mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series SE'
  },
  'Watch6,14': {
    name: 'Apple Watch Series 8 41mm case (GPS)',
    displayName: 'Apple Watch Series 8',
    wristTempSupport: true
  },
  'Watch6,15': {
    name: 'Apple Watch Series 8 45mm case (GPS)',
    displayName: 'Apple Watch Series 8',
    wristTempSupport: true
  },
  'Watch6,16': {
    name: 'Apple Watch Series 8 41mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 8',
    wristTempSupport: true
  },
  'Watch6,17': {
    name: 'Apple Watch Series 8 45mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 8',
    wristTempSupport: true
  },
  'Watch6,18': {
    name: 'Apple Watch Ultra',
    displayName: 'Apple Watch Ultra',
    wristTempSupport: true
  },
  'Watch7,1': {
    name: 'Apple Watch Series 9 41mm case (GPS)',
    displayName: 'Apple Watch Series 9',
    wristTempSupport: true
  },
  'Watch7,2': {
    name: 'Apple Watch Series 9 45mm case (GPS)',
    displayName: 'Apple Watch Series 9',
    wristTempSupport: true
  },
  'Watch7,3': {
    name: 'Apple Watch Series 9 41mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 9',
    wristTempSupport: true
  },
  'Watch7,4': {
    name: 'Apple Watch Series 9 45mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 9',
    wristTempSupport: true
  },
  'Watch7,5': {
    name: 'Apple Watch Ultra 2',
    displayName: 'Apple Watch Ultra 2',
    wristTempSupport: true
  },
  'Watch7,8': {
    name: 'Apple Watch Series 10 42mm case (GPS)',
    displayName: 'Apple Watch Series 10',
    wristTempSupport: true
  },
  'Watch7,9': {
    name: 'Apple Watch Series 10 46mm case (GPS)',
    displayName: 'Apple Watch Series 10',
    wristTempSupport: true
  },
  'Watch7,10': {
    name: 'Apple Watch Series 10 42mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 10',
    wristTempSupport: true
  },
  'Watch7,11': {
    name: 'Apple Watch Series 10 46mm case (GPS+Cellular)',
    displayName: 'Apple Watch Series 10',
    wristTempSupport: true
  }
};
// https://stackoverflow.com/questions/26028918/how-to-determine-the-current-iphone-device-model
// https://www.theiphonewiki.com/wiki/Models
// https://gist.github.com/adamawolf/3048717
// Needs to be updated when new devices come out
// Kirill: older/unsupported devices are excluded for brevity
/**
 * @dbrefEnum
 */
export const IOS_DEVICE_MODEL = {
  'iPhone8,1': 'iPhone 6s',
  'iPhone8,2': 'iPhone 6s Plus',
  'iPhone8,4': 'iPhone SE',
  'iPhone9,1': 'iPhone 7',
  'iPhone9,3': 'iPhone 7',
  'iPhone9,2': 'iPhone 7 Plus',
  'iPhone9,4': 'iPhone 7 Plus',
  'iPhone10,1': 'iPhone 8',
  'iPhone10,4': 'iPhone 8',
  'iPhone10,2': 'iPhone 8 Plus',
  'iPhone10,5': 'iPhone 8 Plus',
  'iPhone10,3': 'iPhone X',
  'iPhone10,6': 'iPhone X',
  'iPhone11,2': 'iPhone XS',
  'iPhone11,4': 'iPhone XS Max',
  'iPhone11,6': 'iPhone XS Max',
  'iPhone11,8': 'iPhone XR',
  'iPhone12,1': 'iPhone 11',
  'iPhone12,3': 'iPhone 11 Pro',
  'iPhone12,5': 'iPhone 11 Pro Max',
  'iPhone12,8': 'iPhone SE (2nd generation)',
  'iPhone13,1': 'iPhone 12 mini',
  'iPhone13,2': 'iPhone 12',
  'iPhone13,3': 'iPhone 12 Pro',
  'iPhone13,4': 'iPhone 12 Pro Max',
  'iPhone14,2': 'iPhone 13 Pro',
  'iPhone14,3': 'iPhone 13 Pro Max',
  'iPhone14,4': 'iPhone 13 mini',
  'iPhone14,5': 'iPhone 13',
  'iPhone14,6': 'iPhone SE (3rd generation)',
  'iPhone14,7': 'iPhone 14',
  'iPhone14,8': 'iPhone 14 Plus',
  'iPhone15,2': 'iPhone 14 Pro',
  'iPhone15,3': 'iPhone 14 Pro Max',
  'iPhone15,4': 'iPhone 15',
  'iPhone15,5': 'iPhone 15 Plus',
  'iPhone16,1': 'iPhone 15 Pro',
  'iPhone16,2': 'iPhone 15 Pro Max',
  'iPhone17,1': 'iPhone 16 Pro',
  'iPhone17,2': 'iPhone 16 Pro Max',
  'iPhone17,3': 'iPhone 16',
  'iPhone17,4': 'iPhone 16 Plus',
  'iPad2,1': 'iPad 2',
  'iPad2,2': 'iPad 2',
  'iPad2,3': 'iPad 2',
  'iPad2,4': 'iPad 2',
  'iPad2,5': 'iPad mini',
  'iPad2,6': 'iPad mini',
  'iPad2,7': 'iPad mini',
  'iPad3,1': 'iPad (3rd generation)',
  'iPad3,2': 'iPad (3rd generation)',
  'iPad3,3': 'iPad (3rd generation)',
  'iPad3,4': 'iPad (4th generation)',
  'iPad3,5': 'iPad (4th generation)',
  'iPad3,6': 'iPad (4th generation)',
  'iPad4,1': 'iPad Air',
  'iPad4,2': 'iPad Air',
  'iPad4,3': 'iPad Air',
  'iPad4,4': 'iPad mini 2',
  'iPad4,5': 'iPad mini 2',
  'iPad4,6': 'iPad mini 2',
  'iPad4,7': 'iPad mini 3',
  'iPad4,8': 'iPad mini 3',
  'iPad4,9': 'iPad mini 3',
  'iPad5,1': 'iPad mini 4',
  'iPad5,2': 'iPad mini 4',
  'iPad5,3': 'iPad Air 2',
  'iPad5,4': 'iPad Air 2',
  'iPad6,3': 'iPad Pro (9.7-inch)',
  'iPad6,4': 'iPad Pro (9.7-inch)',
  'iPad6,7': 'iPad Pro (12.9-inch) (1st generation)',
  'iPad6,8': 'iPad Pro (12.9-inch) (1st generation)',
  'iPad6,11': 'iPad (5th generation)',
  'iPad6,12': 'iPad (5th generation)',
  'iPad7,1': 'iPad Pro (12.9-inch) (2nd generation)',
  'iPad7,2': 'iPad Pro (12.9-inch) (2nd generation)',
  'iPad7,3': 'iPad Pro (10.5-inch)',
  'iPad7,4': 'iPad Pro (10.5-inch)',
  'iPad7,5': 'iPad (6th generation)',
  'iPad7,6': 'iPad (6th generation)',
  'iPad7,11': 'iPad (7th generation)',
  'iPad7,12': 'iPad (7th generation)',
  'iPad8,1': 'iPad Pro (11-inch) (1st generation)',
  'iPad8,2': 'iPad Pro (11-inch) (1st generation)',
  'iPad8,3': 'iPad Pro (11-inch) (1st generation)',
  'iPad8,4': 'iPad Pro (11-inch) (1st generation)',
  'iPad8,5': 'iPad Pro (12.9-inch) (3rd generation)',
  'iPad8,6': 'iPad Pro (12.9-inch) (3rd generation)',
  'iPad8,7': 'iPad Pro (12.9-inch) (3rd generation)',
  'iPad8,8': 'iPad Pro (12.9-inch) (3rd generation)',
  'iPad8,9': 'iPad Pro (11-inch) (2nd generation)',
  'iPad8,10': 'iPad Pro (11-inch) (2nd generation)',
  'iPad8,11': 'iPad Pro (12.9-inch) (4th generation)',
  'iPad8,12': 'iPad Pro (12.9-inch) (4th generation)',
  'iPad11,1': 'iPad mini (5th generation)',
  'iPad11,2': 'iPad mini (5th generation)',
  'iPad11,3': 'iPad Air (3rd generation)',
  'iPad11,4': 'iPad Air (3rd generation)',
  'iPad11,6': 'iPad (8th generation)',
  'iPad11,7': 'iPad (8th generation)',
  'iPad12,1': 'iPad 9th Gen (WiFi)',
  'iPad12,2': 'iPad 9th Gen (WiFi+Cellular)',
  'iPad13,1': 'iPad Air (4th generation)',
  'iPad13,2': 'iPad Air (4th generation)',
  'iPad13,4': 'iPad Pro (11-inch) (3rd generation)',
  'iPad13,5': 'iPad Pro (11-inch) (3rd generation)',
  'iPad13,6': 'iPad Pro (11-inch) (3rd generation)',
  'iPad13,7': 'iPad Pro (11-inch) (3rd generation)',
  'iPad13,8': 'iPad Pro (12.9-inch) (5th generation)',
  'iPad13,9': 'iPad Pro (12.9-inch) (5th generation)',
  'iPad13,10': 'iPad Pro (12.9-inch) (5th generation)',
  'iPad13,11': 'iPad Pro (12.9-inch) (5th generation)',
  'iPad13,16': 'iPad Air 5th Gen (WiFi)',
  'iPad13,17': 'iPad Air 5th Gen (WiFi+Cellular)',
  'iPad13,18': 'iPad 10th Gen',
  'iPad13,19': 'iPad 10th Gen',
  'iPad14,1': 'iPad mini 6th Gen (WiFi)',
  'iPad14,2': 'iPad mini 6th Gen (WiFi+Cellular)',
  'iPad14,3': 'iPad Pro 11 inch 4th Gen',
  'iPad14,4': 'iPad Pro 11 inch 4th Gen',
  'iPad14,5': 'iPad Pro 12.9 inch 6th Gen',
  'iPad14,6': 'iPad Pro 12.9 inch 6th Gen',
  'iPad14,8': 'iPad Air 6th Gen',
  'iPad14,9': 'iPad Air 6th Gen',
  'iPad14,10': 'iPad Air 7th Gen',
  'iPad14,11': 'iPad Air 7th Gen',
  'iPad16,3': 'iPad Pro 11 inch 5th Gen',
  'iPad16,4': 'iPad Pro 11 inch 5th Gen',
  'iPad16,5': 'iPad Pro 12.9 inch 7th Gen',
  'iPad16,6': 'iPad Pro 12.9 inch 7th Gen'
};